import messages from './messages'
import { Locale } from '~/models/locale'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: Locale.DE,
  messages,
}))
